module.exports = __webpack_public_path__ + "static/img/dmg.f24ca0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/dmg.png
// module id = vPzF
// module chunks = 53